// Checking for EST and IST time. If time is before 4:00 am Update the current date to previous date
export function checkAndUpdateDate() {
  const currentDate = new Date();
  const currentHours = currentDate.getHours();
  if (currentHours < 4) {
    currentDate.setDate(currentDate.getDate() - 1);
    return currentDate;
  }
  return currentDate;
}
export const updatedDate = checkAndUpdateDate();
export const todayDate = updatedDate.toISOString().slice(0, 10);
